import React from "react";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";

export default ({ url }) => {
  const data = useStaticQuery(graphql`
    query {
      playerfm: imageSharp(fixed: { originalName: { eq: "playerfm.png" } }) {
        fixed(width: 165) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  `);
  return (
    <a href={url}>
      <Img fixed={data.playerfm.fixed} />
    </a>
  );
};
